import { Shadows } from '@mui/material'

export const elevation = {
  boxShadow: {
    categoryCard: ' 0px 0px 4px 0px #07070714,  0px 0px 12px 0px #64646414',
    sectionCard: ' 0px 2px 2px 0px #37373705,  0px 0px 8px 0px #64646433',
    promotionBanner: ' 0px 2px 12px 0px #14141452,  0px 0px 4px 0px #07070729',
    carouselCard: ' 0px 4px 4px 0px #0707070a,  0px 2px 12px 0px #64646414',
    popover: ' 0px 0px 8px 0px #0707070a,  0px 0px 16px 0px #1414140a',
    barTop: ' 0px 2px 4px 0px #37373705,  0px 2px 8px 0px #1414140a',
    barDown: ' 0px -2px 4px 0px #37373705,  0px -2px 8px 0px #1414140a',
    right: ' 4px 2px 12px 0px #1414140a',
  },
  tableStroke: {
    top: 'innerShadow 0px 1px 0px 0px #e9e9e9',
    bottom: 'innerShadow 0px -1px 0px 0px #e9e9e9',
    right: 'innerShadow -1px 0px 0px 0px #e9e9e9',
    left: 'innerShadow 1px 0px 0px 0px #e9e9e9',
    topLeft: 'innerShadow 1px 1px 0px 0px #e9e9e9',
    topRight: 'innerShadow -1px 1px 0px 0px #e9e9e9',
    leftRight: 'innerShadow 1px 0px 0px 0px #e9e9e9, innerShadow -1px 0px 0px 0px #e9e9e9',
    topBottom: 'innerShadow 0px 1px 0px 0px #e9e9e9, innerShadow 0px -1px 0px 0px #e9e9e9',
    topLeftBottom: 'innerShadow 1px 1px 0px 0px #e9e9e9, innerShadow 0px -1px 0px 0px #e9e9e9',
    bottomLeft: 'innerShadow 1px -1px 0px 0px #e9e9e9',
    topRightBottom: 'innerShadow -1px 1px 0px 0px #e9e9e9, innerShadow 0px -1px 0px 0px #e9e9e9',
    bottomRight: 'innerShadow -1px 0px 0px 0px #e9e9e9, innerShadow 0px -1px 0px 0px #e9e9e9',
    fullStroke: 'innerShadow -1px 1px 0px 0px #e9e9e9, innerShadow 1px -1px 0px 0px #e9e9e9',
  },
}

export const shadowsArray = Array(1).fill('none') as Shadows
export const shadowValue = Object.values(elevation)
  .flatMap((values) => Object.values(values))
  .filter((value) => typeof value === 'string')

export type ElevationType = typeof elevation
